<template>
    <div class="simple-page-top">
        <div class="page-top-container">
            <div class="left">
                <img :src="logo" alt="">
                <span>{{name}}</span>
            </div>
            <div class="right">
                <span class="txt1">服务热线：</span>
                <span class="phone-number">400-931-6788</span>
                <span class="line"></span>
                <a class="wx-logo" href="javascript:;">
                    <i></i>
                    <div class="ewm-box" >
                        <img :src="ewm" alt="">
                        <p>
                            万家微信服务号
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import url from '../../../config/url';
    export default {
        props:{
            name: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                ewm:  url.static + "/img/wx-ewm.jpg",
                logo:  url.static + "/img/wanjia-logo.png",
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/simpleHeaderBar";
</style>



// WEBPACK FOOTER //
// src/components/Common/simpleHeaderBar.vue